import { createReducer, on } from '@ngrx/store';
import { ProjectTemplateDefinition } from './models/project-template-definition.model';
import {
  ProjectTemplateDefinitionResolverEnteredAction,
  ProjectTemplateDefinitionLoadedAction,
  LoadProjectTemplateDefinitionErroredAction,
} from './project-template-definition.actions';

export interface ProjectTemplateDefinitionState {
  templateDefinition: ProjectTemplateDefinition;
  apiErrorCode: number;
}

export const initialState: ProjectTemplateDefinitionState = {
  templateDefinition: null,
  apiErrorCode: null,
};

export const projectTemplateDefinitionReducer = createReducer(
  initialState,
  on(ProjectTemplateDefinitionResolverEnteredAction, (state) => ({
    ...state,
    templateDefinition: null,
    apiErrorCode: null,
  })),
  on(ProjectTemplateDefinitionLoadedAction, (state, { definition }) => ({
    ...state,
    templateDefinition: definition,
  })),
  on(LoadProjectTemplateDefinitionErroredAction, (state, { statusCode }) => ({
    ...state,
    apiErrorCode: statusCode,
  })),
);
